import styled from 'styled-components';
import flex from './../../styles/flex';
import { smaller, breakpoints } from './../../styles/responsive';
import FontAwesomeIcon from './../../icons/Icon.js';
import { FaBars } from 'react-icons/fa';
import { ELEMENTS, zIndexFor } from './../../styles/zindex';


import { hover } from './../../styles/mixins';

export const MenuBar = styled.div(({ theme }) => ({
  position: 'relative',
  ...flex.horizontal,
  ...flex.centerHorizontalV,
  // ...flex.justifyEnd,
  justifyContent: 'space-between',
  ...zIndexFor(ELEMENTS.MENUBAR),
  height: 72, // balanced header height
  width: '100%',
  padding: '10px 14px',
  boxSizing: 'border-box',
  backgroundColor: theme.name === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(242, 242, 242, 0.7)',
  backdropFilter: 'blur(18px) saturate(140%)',
  WebkitBackdropFilter: 'blur(18px) saturate(140%)',
  borderBottom: theme.name === 'dark' ? '1px solid rgba(255,255,255,0.14)' : '1px solid rgba(255,255,255,0.7)',
  boxShadow: theme.name === 'dark' ? '0 8px 24px rgba(0,0,0,0.28)' : '0 8px 24px rgba(0,0,0,0.12)',
  opacity: 0
}));

export const Icons = styled.div(({ $isMobile }) => ({
  ...flex.horizontal,
  ...flex.centerHorizontalV,
  alignItems: 'center',
  height: '100%',
  marginRight: 10,
  overflow: 'visible',
  maxWidth: $isMobile ? 'unset' : '65vw',
  position: 'relative',
  scrollbarWidth: 'thin'
}));

export const Header = styled.div({
  ...flex.horizontal,
  ...flex.centerHorizontal,
  alignItems: 'center',
  userSelect: 'none',
  cursor: 'default',
  minWidth: 25,
  height: '100%',
  marginLeft: 8,
  marginRight: 12,
  transition: 'all 150ms linear',
  img: {
    display: 'block',
    maxHeight: '100%',
    width: 'auto',
    objectFit: 'contain'
  }
});

export const Item = styled.div(
  {
    ...flex.horizontal,
    ...flex.centerHorizontal,
    userSelect: 'none',
    cursor: 'default',
    minWidth: 'max-content',
    padding: `0 8px`,
    height: '100%',
    transition: 'all 150ms linear',
    whiteSpace: 'nowrap',
    alignItems: 'center'
  },
  ({ selected, onClick, theme, $isMobile, $menuOpen }) => ({
    ...(selected && {
      backgroundColor: '#2b85f2'
    }),
    ...(onClick &&
      !selected && {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.name === 'dark' ? '#193046' : '#d7dee0'
        }
      }),
    ...($isMobile && {
      position: 'absolute',
      top: '58px',
      right: 0,
      display: $menuOpen ? 'flex' : 'none',
      flexDirection: 'column',
      alignItems: 'stretch',
      width: 200,
      height: 'auto',
      padding: '10px 12px',
      borderRadius: 12,
      background: theme.name === 'dark' ? 'rgba(7, 15, 32, 0.95)' : 'rgba(255,255,255,0.97)',
      border: theme.name === 'dark' ? '1px solid rgba(255,255,255,0.14)' : '1px solid rgba(0,0,0,0.08)',
      boxShadow: '0 12px 26px rgba(0,0,0,0.32)',
      zIndex: 30
    })
  })
);

export const HamburgerButton = styled.button(({ theme, $isAndroid }) => ({
  width: $isAndroid ? 46 : 42,
  height: $isAndroid ? 46 : 42,
  borderRadius: 10,
  border: $isAndroid
    ? '1px solid rgba(159,214,255,0.75)'
    : theme.name === 'dark' ? '1px solid rgba(255,255,255,0.16)' : '1px solid rgba(0,0,0,0.12)',
  background: $isAndroid
    ? 'linear-gradient(180deg, rgba(6,18,40,1), rgba(4,12,30,0.98))'
    : theme.name === 'dark' ? 'rgba(12,20,39,0.9)' : 'rgba(255,255,255,0.95)',
  boxShadow: $isAndroid ? '0 4px 12px rgba(0,0,0,0.28)' : 'none',
  display: 'inline-flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: $isAndroid ? 5 : 4,
  cursor: 'pointer'
}));



export const HamburgerIcon = styled(FaBars)(({ $isAndroid, theme }) => ({
  width: $isAndroid ? 20 : 18,
  height: $isAndroid ? 20 : 18,
  color: $isAndroid ? '#F3F8FF' : (theme.name === 'dark' ? '#e5edff' : '#0f172a')
}));

export const Link = styled.button(
  {
    appearance: 'none',
    border: 0,
    background: 'transparent',
    textDecoration: 'none',
    borderBottom: '2px solid transparent',
    transition: 'all 120ms linear',
    marginRight: 10,
    padding: '10px 2px',
    minHeight: 44,
    '&:last-of-type': {
      margin: 0
    },
    fontSize: 'clamp(14px, 0.5vw + 11px, 18px)', // responsive menu size
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    ...hover({
      borderBottom: '2px solid #4682B4'
    }),
    '&:focus-visible': {
      outline: '2px solid #58a6ff',
      outlineOffset: 3,
      borderRadius: 6
    },
    [smaller(breakpoints.sm)]: {
      width: '100%',
      justifyContent: 'flex-start',
      marginRight: 0,
      padding: '10px 6px'
    }
  },
  ({ active, theme }) => ({
    color: active ? '#58a6ff' : (theme.name === 'dark' ? 'white' : 'black'),
    borderBottomColor: active ? '#58a6ff' : 'transparent',
    fontWeight: active ? 600 : 400
  })
);


export const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
  width: `25px !important`, //to increase Icon Size
  height: `25px !important`,
  fill: theme.name === 'dark' ? 'white' : 'black'
}));
